// extracted by mini-css-extract-plugin
export default {"span":"Text_span__NCCBY"};